import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { CUSTOM_CODE_FRAGMENT } from 'features/inventory/api/fragments/customCode'
import { DOMAIN_VIEWABILITY_TOOL_FRAGMENT } from 'features/inventory/domain'
import { DOMAIN_PREBID_STACK_FRAGMENT } from 'features/inventory/domain/api/fragments/domainPrebidStack'
import { DOMAIN_PRICE_GENIUS_FRAGMENT } from 'features/inventory/domain/api/fragments/domainPriceGenius'
import { DOMAIN_REFRESHER_FRAGMENT } from 'features/inventory/domain/api/fragments/domainRefresher'
import { DOMAIN_RICH_PLACEMENT_MULTI_ANCHOR_CONFIGURATION_FRAGMENT } from 'features/inventory/domain/api/fragments/domainRichPlacementMultiAnchorConfiguration'
import { DOMAIN_UNFILLED_RECOVERY_FRAGMENT } from 'features/inventory/domain/api/fragments/domainUnfilledRecovery'
import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainDTO } from '../types/domainDTO'

type Props = {
  ability: Ability
}

export const DOMAIN_FRAGMENT = ({ ability }: Props): TypedDocumentNode<DomainDTO> => gql`
  ${ALERT_FRAGMENT}
  ${CUSTOM_CODE_FRAGMENT}
  ${DOMAIN_PREBID_STACK_FRAGMENT}
  ${DOMAIN_PRICE_GENIUS_FRAGMENT}
  ${DOMAIN_REFRESHER_FRAGMENT}
  ${DOMAIN_UNFILLED_RECOVERY_FRAGMENT(ability)}
  ${DOMAIN_VIEWABILITY_TOOL_FRAGMENT}
  ${DOMAIN_RICH_PLACEMENT_MULTI_ANCHOR_CONFIGURATION_FRAGMENT}

  fragment DomainFragment on Domain {
    id
    activeAbTest {
      id
    }
    alerts {
      ...AlertFragment
    }
    createdAt
    customCode {
      ...CustomCodeFragment
    }
    customCodeEnabled
    domainAmazon {
      id
    }
    domainPrebidStack {
      ...DomainPrebidStackFragment
    }
    domainPriceGenius {
      ...DomainPriceGeniusFragment
    }
    domainRefresher {
      ...DomainRefresherFragment
    }
    domainRichPlacementMultianchorConfiguration {
      ...DomainRichPlacementMultiAnchorConfigurationFragment
    }
    domainUnfilledRecovery {
      ...DomainUnfilledRecoveryFragment
    }
    domainViewabilityTools {
      ...DomainViewabilityToolFragment
    }
    name
    overriddenByYieldbird
    prebidStackEnabled
    priceGeniusEnabled
    pubAdsServiceRefresh
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
    workspace {
      id
    }
  }
`
